import React from 'react';
import PropTypes from 'prop-types';
import CreateEditSlots from './CreateEdit';
import ButtonsBlock from './ButtonsBlock';
import {Button} from "../../../../../components/Button";

import './TourSchedule.scss';

const Schedule = (props) => {
  const {
    daysArr,
    daysIndex,
    timeSlots,
    scheduleIndex,
    edit
  } = props;
  const daysIndexes = Object.keys(daysIndex);

  return (
    <li className="tour-schedule__item">
      <div className="tour-schedule__item-block tour-schedule__item-days">
        {
          daysIndexes.map((item) => {
            return (
              <p key={`time_slot_key_${daysArr[item]}`}>
                {daysArr[item]}
              </p>
            )
          })
        }
      </div>
      <div className="tour-schedule__item-block tour-schedule__item-time">
        {
          timeSlots.map((item) => {
            return (
              <div key={`time_slots_${item.startTime}_ ${item.endTime}`}>
                <span>{item.startTime} </span>-
                <span> {item.endTime}</span>
              </div>
            )
          })
        }
      </div>
      <div className="tour-schedule__item-block tour-schedule__item-button">
        <Button
          name="Edit"
          onClick={() => edit(scheduleIndex)}
        />
      </div>
    </li>
  )
};

Schedule.propTypes = {
  edit: PropTypes.func,
  daysArr: PropTypes.array,
  daysIndex: PropTypes.object,
  timeSlots: PropTypes.array,
  scheduleIndex: PropTypes.number,
};


class TimeSlots extends React.Component {
  constructor(props) {
    super(props);
    this.createNewSchedule = this.createNewSchedule.bind(this);
    this.saveNewSchedule = this.saveNewSchedule.bind(this);
    this.setScheduleForEdit = this.setScheduleForEdit.bind(this);
    this.state = {
      daysArr: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      usedDays: {},
      blockForEdit: {
        slotIndex: null,
        daysIndex: {},
        timeSlots: [],
      },
      isShowCreateEdit: false,
      schedules: []
    }
  }

  static propTypes = {
    onUpdatedTimeSlots: PropTypes.func,
    errorTourDates: PropTypes.string
  };

  componentWillMount(){
    this.setData(this.props)
  }

  componentWillReceiveProps(next) {
    this.setData(next)
  }


  setData(props){
    if (props.schedules && props.schedules.length > 0) {
      const data = props.schedules;

      const groupData = {};
      for (let i = 0; i < data.length; i++) {
        if (!groupData[data[i].groupName])
          groupData[data[i].groupName] = [];
        let isAdd = true;
        for (let k = 0; k < groupData[data[i].groupName].length; k++) {
          if (groupData[data[i].groupName][k].startTime === data[i].startTime && groupData[data[i].groupName][k].endTime === data[i].endTime) {
            isAdd = false;
          }
        }

        if (isAdd) {
          groupData[data[i].groupName].push({
            startTime: data[i].startTime,
            endTime: data[i].endTime
          });
        }
      }

      const groupDataKeys = Object.keys(groupData);

      const schedules = [];
      const usedDays = {};
      for (let i = 0; i < groupDataKeys.length; i++) {
        const schedule = {};
        schedule.daysIndex = {};
        const indexDays = groupDataKeys[i].split('_');

        for (let k = 0; k < indexDays.length; k++) {
          schedule.daysIndex[indexDays[k]] = true;
          usedDays[indexDays[k]] = true;
        }
        schedule.timeSlots = groupData[groupDataKeys[i]];
        schedules.push(schedule)
      }
      this.setState({schedules, usedDays});
      // console.log(groupData, data, schedules, usedDays)
    }
  }

  setScheduleForEdit(index) {
    const {schedules, usedDays} = this.state;
    const daysIndexKeys = Object.keys(schedules[index].daysIndex);
    for (let i = 0; i < daysIndexKeys.length; i++) {
      delete usedDays[daysIndexKeys[i]]
    }
    this.setState({isShowCreateEdit: false}, () => {
      setTimeout(() => this.setState({
        blockForEdit: {
          slotIndex: index,
          daysIndex: schedules[index].daysIndex,
          timeSlots: schedules[index].timeSlots,
        },
        isShowCreateEdit: true,
        usedDays
      }), 100)
    });
  }

  createNewSchedule(e) {
    this.setState({
      isShowCreateEdit: true,
      blockForEdit: {
        slotIndex: null,
        daysIndex: {
          [e]: true
        },
        timeSlots: [],
      },
    })
  }

  saveNewSchedule(data) {
    const {
      schedules,
      usedDays
    } = this.state;
    let selectedDays = data.selectedDaysIndex;
    if (!data.slotIndex && data.slotIndex !== 0)
      schedules.push({
        daysIndex: data.selectedDaysIndex,
        timeSlots: data.timeSlots,
      });
    else if (data.timeSlots.length === 0) {
      schedules.splice(data.slotIndex, 1);
      selectedDays = {};
    } else
      schedules[data.slotIndex] = {
        daysIndex: data.selectedDaysIndex,
        timeSlots: data.timeSlots,
      };


    this.setState({
      schedules,
      usedDays: Object.assign(usedDays, selectedDays),
      blockForEdit: {
        slotIndex: null,
        daysIndex: {},
        timeSlots: [],
      },
      isShowCreateEdit: false
    }, () => this.props.onUpdatedTimeSlots(this.processingTimeSlotResponse(this.state.schedules)))
  }

  processingTimeSlotResponse(data) {
    const result = [];
    for (let i = 0; i < data.length; i++) {
      const days = Object.keys(data[i].daysIndex);
      const groupName = days.join('_');
      const slots = data[i].timeSlots;
      for (let j = 0; j < days.length; j++) {
        for (let k = 0; k < slots.length; k++) {
          result.push({
            groupName,
            weakDay: days[j],
            startTime: slots[k].startTime,
            endTime: slots[k].endTime
          })
        }
      }
    }
    return result;
  }

  render() {
    const {
      daysArr,
      usedDays,
      schedules,
      blockForEdit,
      isShowCreateEdit
    } = this.state;

    const {
      errorTourDates
    } = this.props;

    return (
      <div className="tour-schedule">
        <h3 className="tour-schedule__title">Tour Schedule</h3>
        { errorTourDates  && <span className="error-block">{errorTourDates}</span> }
        {
          isShowCreateEdit ?
            <CreateEditSlots
              usedDays={usedDays}
              slotIndex={blockForEdit.slotIndex}
              timeSlots={blockForEdit.timeSlots.map((item, index) => {
                return {
                  id: index + 1,
                  startTime: item.startTime,
                  endTime: item.endTime
                }
              })}
              selectedDays={blockForEdit.daysIndex}
              nameDays={daysArr}
              save={this.saveNewSchedule}
            /> :
            <div>
              {
                schedules.length > 0 ?
                  <div className="tour-schedule__wrap">
                    <ul className="tour-schedule__column-title">
                      <li className="tour-schedule__column-item">Days</li>
                      <li className="tour-schedule__column-item">Time</li>
                    </ul>
                    <ul className="tour-schedule__list">
                      {
                        schedules.map((item, index) => {
                          return (
                            <Schedule
                              key={`schedule_component-${JSON.stringify(item.daysIndex)}`}
                              daysArr={daysArr}
                              scheduleIndex={index}
                              daysIndex={item.daysIndex}
                              timeSlots={item.timeSlots}
                              edit={this.setScheduleForEdit}
                            />
                          )
                        })
                      }
                    </ul>
                  </div>: null
              }

              <ButtonsBlock
                days={daysArr}
                usedDays={usedDays}
                setSelectedDays={this.createNewSchedule}
              />
            </div>
        }
      </div>
    )
  }
}

export default TimeSlots;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/TimeSlots/index.js